import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/firm/partner-firms")({
  beforeLoad: () => {
    throw redirect({ to: "/referrals/partner-firms" });
  },
});
